import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

/**
 * useRealtimeRefresh
 * Hook to automatically trigger a callback when a realtime signal is received.
 * @param {Function} refreshCallback - Function to call when the signal increments.
 * @param {Array} dependencies - Additional dependencies to watch (optional).
 */
export const useRealtimeRefresh = (refreshCallback, dependencies = []) => {
    const realtimeSignal = useSelector(state => state.notificaciones.realtime_signal);
    const prevSignalRef = useRef(realtimeSignal);

    useEffect(() => {
        // Only trigger if the signal has actually incremented and it's not the initial mount
        if (realtimeSignal > prevSignalRef.current) {
            console.log("🔄 Real-time signal detected, triggering refresh callback...");
            if (refreshCallback) {
                refreshCallback();
            }
        }
        prevSignalRef.current = realtimeSignal;
    }, [realtimeSignal, ...dependencies]);
};
